import React from 'react';
import { Center } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export function Account() {
  return (
    <Center w="100%">
      <Outlet />
    </Center>
  );
}
